import DialogIcon from 'features/Widgets/WidgetsCard/DialogIcon'
import ExcludeIcon from 'features/Widgets/WidgetsCard/ExcludeIcon'
import FlowIcon from 'features/Widgets/WidgetsCard/FlowIcon'
import PromotionIcon from 'features/Widgets/WidgetsCard/PromotionIcon'
import SnippetIcon from 'features/Widgets/WidgetsCard/SnippetIcon'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import styles from './WidgetsCard.module.scss'

const Icon = ({ type }) => {
  switch (type) {
    case 'dialog':
      return <DialogIcon />
    case 'snippet':
      return <SnippetIcon />
    case 'exclude':
      return <ExcludeIcon />
    case 'promotion':
      return <PromotionIcon />
    case 'flow':
      return <FlowIcon />
    default:
      return null
  }
}

const WidgetsCard = ({ title, description, type, onClick, to }) => {
  const content = (
    <>
      <div className={styles.cardIcon}>
        <Icon type={type} />
      </div>
      <div className={styles.title}>{title}</div>
      <div className={styles.description}>{description}</div>
    </>
  )

  if (to) {
    return (
      <Link to={to} className={styles.card}>
        {content}
      </Link>
    )
  }

  return (
    <div className={styles.card} onClick={onClick}>
      {content}
    </div>
  )
}

WidgetsCard.propTypes = {
  title: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  type: PropTypes.oneOf(['dialog', 'snippet', 'exclude', 'promotion', 'flow']),
  to: PropTypes.string
}

export default WidgetsCard
